function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
export { _OverloadYield as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/OverloadYield.js
// module id = 788
// module chunks = 0